import * as Sentry from '@sentry/react';

import { getEnvironment, isBrowserSupported, prepareConfig, getInitialScope } from './init/utils';
import getIntegrations from './integrations';
import { Config } from './types';

/**
 * Для того, чтобы добавить какую-то ошибку в ignore,
 * нужно поправить динамическую настройку sentry_js_config в сервисе.
 */

const configureAndInitSentry = (config: Config): void => {
    const { sentryLoggingEnabled, getUser, getExtraData, isDebug } = config;
    if (isDebug) {
        console.error('Initing Sentry with config', config);
    }
    if (!sentryLoggingEnabled) {
        return;
    }

    const environment = getEnvironment();
    const isSupportedBrowser = isBrowserSupported();
    const isLoggingEnabled = isSupportedBrowser || environment.isAutotests;

    if (!isLoggingEnabled) {
        return;
    }

    const clientConfig = prepareConfig(config);

    Sentry.init({
        ...clientConfig,
        integrations: getIntegrations({
            jsBuildFilterKey: config.jsBuildFilterKey,
            replaysOnErrorSampleRate: clientConfig.replaysOnErrorSampleRate,
            tracesSampleRate: clientConfig.tracesSampleRate,
        }),
        transport: Sentry.makeFetchTransport,
        initialScope: getInitialScope({ getUser, getExtraData, environment }),
        debug: config.isDebug,
    });
};

export default configureAndInitSentry;

export { default as pushRequestIdToSentry } from './pushRequestIdToSentry';
export { default as initBrowserClient } from './init/browserClient';
